import { TitleText } from '@calendly/ui/components/typography'
import { useFlag } from '@calendly/feature-check-react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'

import { GmailConfirmation } from 'components/confirmation/gmail_confirmation'
import { useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'
import {
  ConfirmationDetails,
  Container,
  ConfirmationFooter,
  ConfirmationHeader,
  CookieSettingsButton,
  DetailsWrapper,
} from 'components/confirmation/layout'

const Header = () => {
  const { title, subtitle, shouldSeeGmailSniperLink } = useConfirmationPageData()
  const bookingAppRedesign = useFlag('booking_app_redesign', false)

  return (
    <ConfirmationHeader>
      <TitleText level={2} as="h1" size={bookingAppRedesign ? 'medium' : 'large'}>
        {title}
      </TitleText>
      {subtitle}
      {shouldSeeGmailSniperLink && <GmailConfirmation />}
    </ConfirmationHeader>
  )
}

export const ConfirmationPage = () => {
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const isPhone = useDeviceType('isPhone')

  return (
    <Container isPhone={isPhone} bookingAppRedesign={bookingAppRedesign}>
      <Header />
      <DetailsWrapper bookingAppRedesign={bookingAppRedesign}>
        <ConfirmationDetails />
      </DetailsWrapper>
      <ConfirmationFooter />
      {!bookingAppRedesign && <CookieSettingsButton />}
    </Container>
  )
}
